import { Component, OnInit } from '@angular/core';
import { EmployerService } from '../../../employer/services/employer.service';
import { ViewportService } from 'epay-library';

@Component({
  selector: 'epay-termsandconditions',
  templateUrl: './termsandconditions.component.html'
})
export class TermsAndConditionsComponent implements OnInit {
  pagetitle = 'Terms and Conditions'
  terms = '';

  isMobile = false;

  constructor(
    private employerService: EmployerService,
    private viewpointService: ViewportService,) { }

  ngOnInit() {
    this.employerService.getEmployerTerms().subscribe(
      (result: any) => {
        this.terms = result;
      }
    );

    this.viewpointService.IsMobile.subscribe(
      (ismobile: boolean) => this.isMobile = ismobile
    );
  }

}
